import SalesPersons from "../SalesPersons/List";
import SalesPerson from "../SalesPersons";

export const paths = [
  {
    path: "/salesperson/create",
    component: SalesPerson,
  },
  {
    path: "/salespersons/:id",
    component: SalesPerson,
  },
  {
    path: "/salespersons",
    component: SalesPersons,
  },
];
export const SalesPersonRouters = {
  icon: "users",
  testId: "",
  label: "Vendedor(es)",
  tree: [
    {
      icon: "list-ul",
      testId: "",
      path: "/salespersons",
      label: "Listar",
    },
    {
      icon: "plus",
      testId: "",
      path: "/salesperson/create",
      label: "Cadastrar",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/views/Seller/routers.js